/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTEzLjIgOS40MDkzM1Y1LjY3Nkg5LjQ2NjY3VjcuMDY2NjdINC4zMzMzM1Y0LjczMzMzSDUuNzMzMzNWMUgyVjQuNzMzMzNIMy40VjEzLjZIOS40NjY2N1YxNUgxMy4yVjExLjI2NjdIOS40NjY2N1YxMi42NjY3SDQuMzMzMzNWOEg5LjQ2NjY3VjkuNEwxMy4yIDkuNDA5MzNaTTIuOTMzMzMgMS45NDI2N0g0LjhWMy44MDkzM0gyLjkzMzMzVjEuOTQyNjdaTTEwLjQgMTIuMjA5M0gxMi4yNjY3VjE0LjA3NkgxMC40VjEyLjIwOTNaTTEwLjQgNi42MDkzM0gxMi4yNjY3VjguNDc2SDEwLjRWNi42MDkzM1oiIGZpbGw9ImluaGVyaXQiLz4=";